module.exports = __webpack_public_path__ + "img/position-unloading.1745e29a.png";